// Part of the Chili3d Project, under the AGPL-3.0 License.
// See LICENSE file in the project root for full license information.

import { Locale } from "./i18n";

export default {
    display: "简体中文",
    code: "zh-CN",
    translation: {
        "arc.angle": "角度",
        "arc.start": "起点",
        "axis.x": "X 轴",
        "axis.y": "Y 轴",
        "axis.z": "Z 轴",
        "body.arc": "圆弧",
        "body.bolean": "布尔",
        "body.box": "立方体",
        "body.pyramid": "棱锥",
        "body.cylinder": "圆柱",
        "body.cone": "圆锥",
        "body.group": "组",
        "body.sphere": "球体",
        "body.ellipse": "椭圆",
        "body.circle": "圆形",
        "body.face": "面",
        "body.fuse": "合并",
        "body.imported": "导入的模型",
        "body.line": "直线",
        "body.polygon": "多边形",
        "body.prism": "拉伸",
        "body.rect": "矩形",
        "body.revol": "旋转",
        "body.sweep": "扫略",
        "body.wire": "线框",
        "body.editableShape": "可编辑的形状",
        "body.meshNode": "网格节点",
        "body.multiShape": "多形状",
        "box.dx": "长",
        "box.dy": "宽",
        "box.dz": "高",
        "circle.center": "圆心",
        "circle.radius": "半径",
        "ellipsoid.radiusX": "半径X",
        "ellipsoid.radiusY": "半径Y",
        "ellipsoid.radiusZ": "半径Z",
        "ellipse.majorRadius": "长轴",
        "ellipse.minorRadius": "短轴",
        "command.act.alignCamera": "对齐相机",
        "command.boolean.common": "交集",
        "command.boolean.cut": "减去",
        "command.boolean.join": "合并",
        "command.convert.fuse": "融合",
        "command.convert.revol": "旋转",
        "command.convert.sweep": "扫略",
        "command.convert.toFace": "转为面",
        "command.convert.toShell": "转为壳",
        "command.convert.toSolid": "转为体",
        "command.convert.toWire": "转多段线",
        "command.create.arc": "圆弧",
        "command.create.bezier": "贝塞尔",
        "command.create.box": "立方体",
        "command.create.circle": "圆形",
        "command.create.cone": "圆锥",
        "command.create.copyShape": "复制形状",
        "command.create.cylinder": "圆柱",
        "command.create.ellipse": "椭圆",
        "command.create.ellipsoid": "椭球体",
        "command.create.extrude": "拉伸",
        "command.create.folder": "文件夹",
        "command.create.group": "创建组",
        "command.create.line": "直线",
        "command.create.offset": "偏移",
        "command.create.polygon": "多边形",
        "command.create.pyramid": "金字塔",
        "command.create.rect": "矩形",
        "command.create.section": "截面",
        "command.create.sphere": "球体",
        "command.create.thickSolid": "厚体",
        "command.doc.new": "新建文档",
        "command.doc.open": "打开文档",
        "command.doc.save": "保存文档",
        "command.doc.saveToFile": "保存到文件",
        "command.edit.redo": "重做",
        "command.edit.undo": "撤销",
        "command.file.export": "导出",
        "command.file.import": "导入",
        "command.measure.angle": "角度",
        "command.measure.length": "长度",
        "command.measure.select": "选择",
        "command.modify.array": "阵列",
        "command.modify.break": "打断",
        "command.modify.brushAdd": "添加画笔",
        "command.modify.brushRemove": "删除画笔",
        "command.modify.brushClear": "清除画笔",
        "command.modify.chamfer": "倒角",
        "command.modify.deleteNode": "删除节点",
        "command.modify.explode": "分解",
        "command.modify.fillet": "倒角",
        "command.modify.mirror": "镜像",
        "command.modify.move": "移动",
        "command.modify.removeFeature": "删除特征",
        "command.modify.removeShapes": "删除图形",
        "command.modify.rotate": "旋转",
        "command.modify.split": "分割",
        "command.modify.trim": "修剪",
        "command.special.last": "__上一步__",
        "command.test.performace": "性能测试",
        "command.wechat.group": "微信群",
        "command.workingPlane.alignToPlane": "对齐",
        "command.workingPlane.fromSection": "从截面",
        "command.workingPlane.set": "设置",
        "command.workingPlane.toggleDynamic": "动态",
        "common.angle": "角度",
        "common.area": "面积",
        "common.back": "返回",
        "common.cancel": "取消",
        "common.clone": "复制对象",
        "common.color": "颜色",
        "common.confirm": "确定",
        "common.general": "常规",
        "common.length": "长度",
        "common.material": "材质",
        "common.matrix": "矩阵",
        "common.name": "名称",
        "common.normal": "法向量",
        "common.opacity": "不透明度",
        "common.thickness": "厚度",
        "common.type": "类型",
        "common.volume": "体积",
        "dialog.title.selectWorkingPlane": "选择工作平面",
        "entity.editable": "可编辑实体",
        "entity.parameter": "参数化实体",
        "error.default:{0}": "错误: {0}",
        "error.input.cannotInputANumber": "与参照点重合，无法输入 1 个数",
        "error.input.invalidNumber": "输入错误，请输入有效的数字，以,分开",
        "error.input.threeNumberCanBeInput": "参照点为空，只能输入 3 个数",
        "error.input.unsupportedInputs": "超过最大输入数",
        "error.import.unsupportedFileType:{0}": "不支持的文件类型: {0}",
        "error.export.noNodeCanBeExported": "没有可导出的节点",
        "file.format": "文件格式",
        "home.recent": "最近使用",
        "home.welcome": "欢迎使用 湖南创合CAD",
        "items.header": "项目",
        "items.tool.delete": "删除",
        "items.tool.expandAll": "展开所有",
        "items.tool.newFolder": "文件夹",
        "items.tool.unexpandAll": "折叠所有",
        "line.end": "终点",
        "line.start": "起点",
        "line.type.line": "直线",
        "line.type.xline": "构造线",
        "material.texture.image": "图片",
        "material.texture.rotation": "旋转",
        "material.texture.wrapS": "Wrap S",
        "material.texture.wrapT": "Wrap T",
        "material.texture.repeat": "重复",
        "material.texture.offset": "偏移",
        "material.map": "贴图",
        "material.specular": "高光",
        "material.shininess": "高光强度",
        "material.emissive": "自发光",
        "material.specularMap": "高光贴图",
        "material.normalMap": "法线贴图",
        "material.bumpMap": "凹凸贴图",
        "material.roughnessMap": "粗糙度贴图",
        "material.emissiveMap": "自发光贴图",
        "material.metalness": "金属度",
        "material.metalnessMap": "金属度贴图",
        "material.roughness": "粗糙度",
        "model.visible": "可见",
        "option.command.repeat": "重复",
        "option.command.isFace": "面",
        "option.command.thickness": "厚度",
        "option.command.isRoundCorner": "圆角",
        "option.command.isConnected": "相连",
        "option.command.isConvertInstance": "转为实例",
        "option.command.insertPoint": "插入点",
        "polygon.points": "点",
        "prompt.default": "鼠标中键平移视图，Shift + 中键旋转视图，中键滚动缩放视图",
        "prompt.deleteDocument{0}": "是否删除 {0} ？",
        "prompt.pickCircleCenter": "请选择圆心  按 ESC 键取消",
        "prompt.pickFistPoint": "请选择第一个点, 按 ESC 键取消",
        "prompt.pickNextPoint": "请选择下一个点， 按 ESC 键取消",
        "prompt.pickRadius": "请选择半径，按 ESC 键取消",
        "prompt.polygon.close": "闭合",
        "prompt.saveDocument{0}": "是否保存对 {0} 的更改？",
        "prompt.select.edges": "请选择边",
        "prompt.select.faces": "请选择面",
        "prompt.select.models": "请选择模型",
        "prompt.select.noModelSelected": "未选择任何模型",
        "prompt.select.section": "请选择截面",
        "prompt.select.shape": "选择形状",
        "prompt.select.solids": "请选择实体",
        "prompt.select.path": "请选择路径",
        "prompt.select.vertexes": "请选择点",
        "prompt.select.wires": "请选择线",
        "toast.snap.notFoundValidPoint": "未找到有效的点",
        "properties.group.transform": "转换",
        "properties.header": "属性",
        "properties.multivalue": "多个值",
        "rect.dx": "长",
        "rect.dy": "宽",
        "ribbon.group.2d": "2D",
        "ribbon.group.3d": "3D",
        "ribbon.group.act": "场景",
        "ribbon.group.boolean": "布尔运算",
        "ribbon.group.converter": "转换",
        "ribbon.group.draw": "绘制",
        "ribbon.group.importExport": "导入/导出",
        "ribbon.group.measure": "测量",
        "ribbon.group.modify": "修改",
        "ribbon.group.other": "其他",
        "ribbon.group.selection": "选择",
        "ribbon.group.tools": "工具",
        "ribbon.group.workingPlane": "工作平面",
        "ribbon.tab.draw": "绘图",
        "ribbon.tab.file": "文件",
        "ribbon.tab.tools": "工具",
        "ribbon.tab.startup": "开始",
        "snap.center": "圆心",
        "snap.end": "端点",
        "snap.intersection": "交点",
        "snap.mid": "中点",
        "snap.perpendicular": "垂点",
        "snap.nearest": "最近点",
        "statusBar.snap": "捕捉",
        "statusBar.tracking": "追踪",
        "toast.command.{0}excuting": "{0}命令正在执行",
        "toast.converter.error": "转换错误",
        "toast.converter.invalidColor": "无效的颜色",
        "toast.delete{0}Objects": "删除了 {0} 个对象",
        "toast.document.noActivated": "未打开任何文档",
        "toast.document.saved": "文档已保存",
        "toast.downloading": "正在下载",
        "toast.excuting{0}": "正在执行{0}",
        "toast.fail": "失败",
        "toast.read.error": "读取错误",
        "toast.select.noSelected": "未选择任何对象",
        "toast.success": "成功",
        "transform.rotation": "旋转",
        "transform.scale": "缩放",
        "transform.translation": "位移",
        "vertex.point": "点",
    },
} satisfies Locale;
